// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf58a2b1","455":"4381534f","879":"75e840bc","977":"ff8f677b"}[chunkId] + ".chunk.js";
};